// @ts-nocheck
import * as React from "react";

const BookLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M19 3H7a3 3 0 00-3 3v12a3 3 0 003 3h12a1 1 0 001-1V4a1 1 0 00-1-1zM7 5h11v10H7a3 3 0 00-1 .18V6a1 1 0 011-1zm0 14a1 1 0 110-2h11v2H7z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(BookLine);
